import {useMutation} from "@tanstack/react-query";

import {removeRepresentativeNoteMutationOptions} from "./remove-representative-note.mutation-options";

export function useRemoveRepresentativeNote(representativeId: string) {
  return useMutation(removeRepresentativeNoteMutationOptions(representativeId));
}
